import React, { useMemo, useState } from "react";
import { Box, Link, Typography } from "@material-ui/core";
import { useDeviceTypes } from "halifax";
import { CarReservation } from "redmond";

import { CarVendorMessagesPopup } from "../CarVendorMessagesPopup";
import { flattenVendorMessages } from "../CarVendorMessagesPopup/component";
import { CANCELLATION_POLICY, FUEL_POLICY } from "./constants";
import { VIEW_IMPORTANT_INFORMATION } from "../CarVendorMessagesPopup/constants";
import "./styles.scss";

export interface ICarInfoContent {
  car: CarReservation;
}

export const CarCancellationPolicy = ({ car }: ICarInfoContent) => {
  const description = car.bookResult.rentalRate.extensions.cancellation.desc;
  if (!description) return null;
  return (
    <>
      <Typography variant="body1" className="cancellation-title">
        {CANCELLATION_POLICY}
      </Typography>
      <Typography variant="body1">{description}</Typography>
    </>
  );
};

export const FuelPolicy = ({ car }: ICarInfoContent) => {
  const fuelPolicy = car.bookResult.rentalRate.extensions.fuelPolicy?.desc;
  if (!fuelPolicy) return null;
  return (
    <>
      <Typography variant="body1" className="fuel-policy-title">
        {FUEL_POLICY}
      </Typography>
      <Typography variant="body1">{fuelPolicy}</Typography>
    </>
  );
};

export const ViewImportantInformationLink = ({ car }: ICarInfoContent) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const { matchesMobile: isMobile } = useDeviceTypes();

  const {
    bookResult: { vendorMessages },
  } = car;
  const messages = useMemo(
    () => flattenVendorMessages(vendorMessages),
    [vendorMessages]
  );

  if (messages.length === 0) return null;

  return (
    <>
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <Link
        component="button"
        className="view-important-information-link"
        onClick={() => setIsPopupOpen(true)}
      >
        <Typography className="view-important-information-link-content" variant="body2">
          {VIEW_IMPORTANT_INFORMATION}
        </Typography>
      </Link>
      {isPopupOpen && (
        <CarVendorMessagesPopup
          vendorMessages={vendorMessages}
          isMobile={isMobile}
          onClose={() => setIsPopupOpen(false)}
        />
      )}
    </>
  );
};

export const CarInfoContent = ({
  car,
}: ICarInfoContent): React.ReactElement | null => {
  if (!car) {
    return null;
  }
  return (
    <Box className="car-shop-room-type-room-details-list">
      <CarCancellationPolicy car={car} />
      <FuelPolicy car={car} />
      <ViewImportantInformationLink car={car} />
    </Box>
  );
};
